import React from 'react';
import { isClientEnv } from '@app/src/utils/validations';
import {
  Wrapper,
  Message,
  Description,
  Detail,
  ButtonExit,
  ButtonWrapper
} from './styled';

const isClient = isClientEnv();

interface Props {
  message: string;
  buttonText: string;
  theme?: string;
  handleClickNext?: Function;
  details?: Array<{}>;
  className?: string;
  children?: any;
}

export const MessageConfirm: React.FC<Props> = ({
  message,
  buttonText,
  details,
  theme,
  handleClickNext,
  className,
  children
}) => {

  const handleClick = () => {
    if (isClient) {
      handleClickNext && handleClickNext();
    }
  };

  const handleClickExit = () => {
    if (isClient) {
      window.location.href = '/mi-cuenta';
    }
  };

  return (
    <Wrapper className={className}>
      {children}
      <Message>{message}</Message>
      {
        details &&
        <Description>
          {
            details.map((detail, key) => 
              detail.price ?
                (
                  <Detail key={key}>
                    {detail.description}: S/ {detail.value}
                  </Detail>
                )
                :
                (
                  <Detail key={key}>
                    {detail.description}: {detail.value}
                  </Detail>
                )
            )
          }
        </Description>
      }
      <ButtonWrapper
        text={buttonText}
        background={theme}
        color="#fff"
        width={184}
        handleClick={handleClick}
      />
      <ButtonExit
        text="Salir"
        background="#fff"
        color={theme}
        width={184}
        handleClick={handleClickExit}
      />
    </Wrapper>
  )
}
